export const SET_FIELD = 'DPT_INKJET_MATERIALS/SET_FIELD';
export const FETCH_DATA = 'DPT_INKJET_MATERIALS/FETCH_DATA';
export const FETCH_DATA_SUCCESS = 'DPT_INKJET_MATERIALS/FETCH_DATA_SUCCESS';
export const FETCH_DATA_ERROR = 'DPT_INKJET_MATERIALS/FETCH_DATA_ERROR';
export const SAVE = 'DPT_INKJET_MATERIALS/SAVE';
export const SAVE_SUCCESS = 'DPT_INKJET_MATERIALS/SAVE_SUCCESS';
export const SAVE_ERROR = 'DPT_INKJET_MATERIALS/SAVE_ERROR';
export const FETCH_ELEMENT = 'DPT_INKJET_MATERIALS/FETCH_ELEMENT';
export const FETCH_ELEMENT_SUCCESS = 'DPT_INKJET_MATERIALS/FETCH_ELEMENT_SUCCESS';
export const FETCH_ELEMENT_ERROR = 'DPT_INKJET_MATERIALS/FETCH_ELEMENT_ERROR';
export const SET_ACTIVE_PAGE = 'DPT_INKJET_MATERIALS/SET_ACTIVE_PAGE';
export const RESET_FORM = 'DPT_INKJET_MATERIALS/RESET_FORM';